import React from "react";
import "./inflation-factor.styles.css";
import { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserData ,selectMSMessageRBAC} from "../../redux/user/user.selectors";
import { canUserEdit,getUserMSRBACMessage } from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";
import {
  Table,
  Spin,
  Input,
  Select,
  Button,
  message,
  Form,
  Modal,
  Radio,
} from "antd";

import API from "../../api";
const { Search } = Input;
const { Option } = Select;
/**
 * @description Component for user management tab
 *
 * @component
 */
class InflationMaster extends Component {
  state = {
    isModalVisible: false,
    isAdd: false,
    currentRecord: null,
    userBranches: null,
    searchText: null,
    searchUserType: 0,
    InflationMasterTableData: [],
    varietyList: [],
    mandiRegionList: [],
    stateList: [],
    hubRegionList: [],
    hubBranchList: [],
    isSpinnerOnLoad: false,
    isSubmitted: false,
    newData: {
      is_active: true,
      Infation_Factor_Id: undefined,
      Mandi_State: "",
      Variety: undefined,
      variety_id: undefined,
      variety_name: "",
      Inflation_Factor: undefined,
      isEdit: false,
    },
    rowData: undefined,
    selectedRegionValue: undefined,
    selectedRegionName: "",
    selectedBranchValue: undefined,
    selectedBranchName: "",
    selectedBranchList: [],
    selectedRegionList: [],
  };
  componentDidMount() {
    this.setState({ isSpinnerOnLoad: true });
    this.getInflationMaster();
    this.getvarietyList();
    this.getStateList();
    // this.getPrimaryHub();
    // this.getHubRegion();
    // this.getHubBranch();
  }

  getvarietyList = async () => {
    this.setState({ isSpinnerOnLoad: true });

    //TODO: change api
    await API.get("/varieties")
      .then((roleData) => {
        this.setState(
          {
            varietyList: roleData.data.data,
          }
        );
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });

    await API.get("/get_states")
      .then((stateLis) => {
        this.setState({
          stateList: stateLis.data.data,
        });
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400)
            message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  getStateList = async () => {
    this.setState({ isSpinnerOnLoad: true });
    ;

    //   await API.get("/list_branch", { headers: headers })
    //     .then((hubList) => {
    //       this.setState({
    //         stateList: hubList.data.data,
    //         isSpinnerOnLoad: false,
    //       });
    //     })
    //     .catch((err) => {
    //       if (err) { 
    //         if (err.response && err.response.status === 400)
    //           message.error("Something went wrong. Please try again later.", 5);
    //         else {
    //           message.error("Something went wrong.. Please try again later.", 5);
    //         }
    //       } else {
    //         message.error("Something went wrong... Please try again later.", 5);
    //       }
    //       this.setState({ isSpinnerOnLoad: false });
    //     });
  };

  getInflationMaster = async () => {
    this.setState({ isSpinnerOnLoad: true });


    await API.get("/inflation_factor")
      .then((varietyResponse) => {

        varietyResponse.data.data.map((dataDetailItem, index) => {
          dataDetailItem.key = index;
          dataDetailItem.isEdit = false;
        });
        this.setState(
          {
            InflationMasterTableData: varietyResponse.data.data,
            // InflationMasterTableData:[],
          },
          () => this.setState({ isSpinnerOnLoad: false, isAdd: true })
        );

      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  setTableData = () => {
    if (this.state.InflationMasterTableData !== undefined || this.state.InflationMasterTableData.length >= 0) {
      const userTableData = this.state.InflationMasterTableData.map((user, index) => {
        return {
          key: user.key,
          is_active: user.is_active,
          Infation_Factor_Id: user.Infation_Factor_Id,
          Mandi_State: user.Mandi_State,
          Variety: user.Variety,
          variety_id: user.variety_id,
          variety_name: user.variety_name,
          Inflation_Factor: user.Inflation_Factor,
          isEdit: user.isEdit,
        };
      });

      let dataAfterSearch = userTableData;

      if (this.state.searchText) {
        dataAfterSearch = dataAfterSearch.filter(
          (item) =>
            (item.Mandi_State !== null &&
              item.Mandi_State
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase())) ||
            (item.variety_name !== null &&
              item.variety_name
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase()))
          // (item.hub_name !== null &&
          //   item.hub_name
          //     .toLowerCase()
          //     .includes(this.state.searchText.toLowerCase())) 
        );
      }

      return dataAfterSearch;
    }
    else {
      return this.state.InflationMasterTableData;
    }
  };

  submitTableRowData = (row, index, isPopup) => {
    this.setState({ isSpinnerOnLoad: true, isSubmitted: true });
    let warningmessage = "";
    if (row.Mandi_State === null || row.Mandi_State === undefined || row.Mandi_State === "") {
      warningmessage = "Please select Mandi State";
    }
    else if (row.variety_name === null || row.variety_name === undefined || row.variety_name === "") {
      warningmessage = "Please select Variety";
    } else if (row.Inflation_Factor === null || row.Inflation_Factor === undefined || row.Inflation_Factor === "") {
      warningmessage = "Please enter Inflation Factor";
    }

    if (
      warningmessage === "" ||
      warningmessage === undefined ||
      warningmessage === null
    ) {
      this.setState({ isSpinnerOnLoad: true });
      this.setState({ isSubmitted: true })
      let data = {

        Infation_Factor_Id: row.Infation_Factor_Id,
        Mandi_State: row.Mandi_State,
        Variety: row.Variety,
        state_id: row.region_id,
        Inflation_Factor: row.Inflation_Factor,
      };



      API.put("/inflation_factor", data, {

      })
        .then((response) => {
          if (response.status === 200 && response.data.status) {
            message.info(response.data.message, 5);
            this.setModalVisibility(false);
            this.getInflationMaster();
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          } else if (!response.data.status) {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error(response.data.message, 5);
            // this.setModalVisibility(false);
          } else {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error("Please try again", 5);
          }
        })
        .catch((err) => {
          if (err) {
            if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
            else {
              message.error("Something went wrong.. Please try again later.", 5);
            }
          } else {
            message.error("Something went wrong... Please try again later.", 5);
          }
          this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          // this.setModalVisibility(false);
        });
    } else {
      this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
      message.error(warningmessage, 5);
    }
  };

  setModalVisibility = (status) => {
    if (status) {
      const nData = {
        is_active: true,
        Infation_Factor_Id: undefined,
        Mandi_State: "",
        Variety: "",
        variety_id: undefined,
        variety_name: "",
        Inflation_Factor: undefined,
        isEdit: false,
      };

      this.setState({ newData: nData });
    }

    this.setState({ isModalVisible: status });
  };

  TableColumnHeader = (props) => {
    const { title, subtitle } = props;
    return (
      <div className="column-header-container">
        <div
          style={{
            color: "white",
            fontSize: "12px",
            whiteSpace: "nowrap",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "11px",
            fontWeight: "normal",
            textAlign: "left",
            // subtitle && title.length < subtitle.length ? "left" : "center"
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };

  createFilters = (label) => {
    let filterData = this.state.InflationMasterTableData;
    //#region remove duplicate objects
    let uniqueFilterData = [];

    filterData.map((mainItem) =>
      uniqueFilterData.filter((item) => item[label] === mainItem[label])
        .length > 0
        ? null
        : uniqueFilterData.push(mainItem)
    );

    uniqueFilterData = uniqueFilterData.map((item) => {
      return {
        text: item[label],
        value: item[label],
      };
    });

    uniqueFilterData.sort((a, b) => a.text.localeCompare(b.text));
    //#endregion

    return uniqueFilterData;
  };

  handleDropdownChange = (value, row, target, index, optionlabel, isPopup) => {
    let a;

    if (isPopup === false) {
      a = this.state.InflationMasterTableData;

      if (target === "is_active") {
        a[row.key].is_active = Boolean(value);
      } else if (target === "Mandi_State") {
        a[row.key].Mandi_State = optionlabel;
        a[row.key].region_id = value;
      } else if (target === "variety_name") {
        a[row.key].variety_name = optionlabel;
        a[row.key].variety_id = value;
        a[row.key].Variety = value;
      }
      this.setState({ InflationMasterTableData: a });
    } else {
      a = this.state.newData;

      if (target === "is_active") {
        a.is_active = Boolean(value);
      } else if (target === "Mandi_State") {
        a.Mandi_State = optionlabel;
        a.region_id = value;
      } else if (target === "variety_name") {
        a.variety_name = optionlabel;
        a.variety_id = value;
        a.Variety = value;
      }
      this.setState({ newData: a });
    }
  };

  handleChange = (e, row, index, name, isPopup) => {
    e.target.name = name;

    var alphaNumericRegex = /^[a-zA-Z0-9]*$/;
    var numberRegex = /^[0-9.]+$/;

    let a;
    if (isPopup === false) {
      a = this.state.InflationMasterTableData;

      if (name === "Inflation_Factor") {
        a[row.key].Inflation_Factor = e.target.value;
      }

      this.setState({ InflationMasterTableData: a });
    } else {
      a = this.state.newData;

      if (name === "Inflation_Factor") {
        a.Inflation_Factor = e.target.value;
      }

      this.setState({ newData: a });
    }
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  handleEditChange = (row, index) => {
    this.setState({ rowData: row });
    let tempData = this.state.InflationMasterTableData.map((item) => {

      if (item.key === row.key) {
        return {
          ...item,
          isEdit: true
        }
      } else {
        return item;
      }
    })
    this.setState({ InflationMasterTableData: tempData });
  };

  handleCancelClick = (rowData, index) => {
    let tempData = this.state.InflationMasterTableData.map((item) => {
      if (item.key === rowData.key) {
        return this.state.rowData
      } else {
        return item;
      }
    })
    this.setState({ InflationMasterTableData: tempData });
  };

  render() {
    const userTableProps = {
      pagination: false,
      size: "default",
      bordered: true,
      scroll: { x: 200, y: window.innerHeight - 250 },
    };

    return (
      <div
        className="mandi-master-container"
        style={{
          height: window.innerHeight - 85,
          marginTop: "-45px",
        }}
      >
        <div className="top-container">

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              placeItems: "flex-end",
              marginRight: "25px",
              marginBottom: "10px",
            }}
          >
            <Search
              disabled={!this.state.isAdd}
              placeholder="Search"
              allowClear
              onChange={(e) => this.setState({ searchText: e.target.value })}
              style={{ width: "25%" }}
            />
            <Button
              className="add-master-button"
              style={{
                height: "25px",
                width: "70px",
                backgroundColor: "#0b133d",
                color: "white",
              }}
              disabled={!canUserEdit(
                this.props.userData,
                null,
                FeatureCodes.MS_INFLATION_FACTOR_EDIT
              ) || !this.state.isAdd}
              onClick={() => this.setModalVisibility(true)}
            >
              &#10010; Add
            </Button>
          </div>
        </div>

        <div>
        <div
        style={{
          marginLeft: "25px",
          marginTop: "-8px",
          fontSize: "14px",
          color: "red",
          display: "flex",
          float: "left",
        }}
      > {getUserMSRBACMessage(this.props.messageAccess,FeatureCodes.MS_INFLATION_FACTOR_EDIT)}
      </div>
        <div
          style={{
            marginRight: "20px",
            marginTop: "-8px",
            fontSize: "15px",
            color: "#0B133D",
            display: "flex",
            float: "right",
          }}
        >Total number of records:&nbsp;
          <b>{this.state.InflationMasterTableData && this.setTableData().length}</b>
        </div>
        </div>

        <Spin
          spinning={this.state.isSpinnerOnLoad}
          size={"large"}
          tip="Loading..."
          style={{ alignSelf: "center", zIndex: 9999, marginTop: "20px" }}
        >
          <Modal
            className="add-master-modal"
            title={"Add Inflation Factor"}
            onCancel={this.handleCancel}
            footer={false}
            visible={this.state.isModalVisible}
            destroyOnClose={true}
          >
            <div className="master-form-container">
              <Form
                layout="horizontal"
                //   onValuesChange={onFormLayoutChange}
                size={"small"}
              // onSubmit={submitTableRowData(this.state.newData)}
              >
                <div className="form-top-container1">
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "60%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Mandi State">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="Mandi_State"
                        defaultValue={this.state.newData.Mandi_State}
                        value={this.state.newData.Mandi_State}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "Mandi_State",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.stateList &&
                          this.state.stateList.length &&
                          this.state.stateList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.state_id}
                              value={hubItem.state_id}
                            >
                              {hubItem.state_name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "60%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Variety">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="variety_name"
                        defaultValue={this.state.newData.variety_name}
                        value={this.state.newData.variety_name}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "variety_name",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.varietyList &&
                          this.state.varietyList.length &&
                          this.state.varietyList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.variety_id}
                              value={hubItem.variety_description}
                            >
                              {hubItem.variety_name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <div
                    className="checkbox-group1"
                    style={{
                      height: "45px",
                      display: "inline-block",
                      width: "60%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Inflation Factor">
                      <Input
                        type="number"
                        style={{ marginRight: "2px" }}
                        maxLength={100}
                        min="0"
                        value={this.state.newData.Inflation_Factor}
                        name="Inflation_Factor"
                        onChange={(e) =>
                          this.handleChange(
                            e,
                            this.state.newData,
                            0,
                            "Inflation_Factor",
                            true
                          )
                        }
                      />
                    </Form.Item>
                  </div>

                </div>

                <div className="form-bottom-container" style={{ marginTop: "10px" }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={this.state.isSubmitted}
                      onClick={() =>
                        this.submitTableRowData(this.state.newData, 0, true)
                      }
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Modal>


          <div className="table-container1" style={{ maxHeight: "450px", width: "99%", margin: "6px 0px" }}>
            <Table
              {...userTableProps}
              columns={[
                {
                  title: "Mandi State",
                  dataIndex: "Mandi_State",
                  key: "Mandi_State",
                  width: 125,
                  filters: this.createFilters("Mandi_State"),
                  onFilter: (value, record) =>
                    record.Mandi_State.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.Mandi_State.localeCompare(b.Mandi_State),
                  render: (record, rowRecord) => {
                    return (
                      <>
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-10px" }}
                        >
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={true}//{!rowRecord.isEdit}
                            className="remarks-select"
                            name="Mandi_State"
                            defaultValue={rowRecord.Mandi_State}
                            value={rowRecord.Mandi_State}
                            onSelect={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "Mandi_State",
                                -0,
                                option.props.children,
                                false
                              )
                            }
                          >
                            {this.state.stateList &&
                              this.state.stateList.length &&
                              this.state.stateList.map((hubItem, idx) => (
                                <Option
                                  key={hubItem.state_id}
                                  value={hubItem.state_id}
                                >
                                  {hubItem.state_name}
                                </Option>
                              ))}
                          </Select>
                        </div>
                      </>
                    );
                  },
                },
                {
                  title: "Variety",
                  dataIndex: "variety_name",
                  key: "variety_name",
                  width: 125,
                  filters: this.createFilters("variety_name"),
                  onFilter: (value, record) =>
                    record.variety_name.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.variety_name.localeCompare(b.variety_name),
                  render: (record, rowRecord) => {
                    return (
                      <>
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-10px" }}
                        >
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={true}//{!rowRecord.isEdit}
                            className="remarks-select"
                            name="variety_name"
                            defaultValue={rowRecord.variety_name}
                            value={rowRecord.variety_name}
                            onSelect={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "variety_name",
                                -0,
                                option.props.children,
                                false
                              )
                            }
                          >
                            {this.state.varietyList &&
                              this.state.varietyList.length &&
                              this.state.varietyList.map((hubItem, idx) => (
                                <Option
                                  key={hubItem.variety_id}
                                  value={hubItem.variety_id}
                                >
                                  {hubItem.variety_name}
                                </Option>
                              ))}
                          </Select>
                        </div>
                      </>
                    );
                  },
                },
                {
                  key: "Inflation_Factor",
                  title: "Inflation Factor",
                  dataIndex: "Inflation_Factor",
                  width: 150,
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.Inflation_Factor - b.Inflation_Factor,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ marginLeft: "-20px" }}>
                          <Input
                            type="number"
                            disabled={!rowRecord.isEdit}
                            style={{ marginRight: "2px" }}
                            maxLength={100}
                            min="0"
                            value={rowRecord.Inflation_Factor}
                            name="Inflation_Factor"
                            onChange={(e) =>
                              this.handleChange(
                                e,
                                rowRecord,
                                index,
                                "Inflation_Factor",
                                false
                              )
                            }
                          />
                        </div>
                      </>
                    );
                  },
                },

                {
                  title: "Action",
                  dataIndex: "Submit",
                  key: "Submit",
                  width: 80,
                  visibility: false,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ display: "inline-flex", width: "100%" }}>
                          <Button
                          className={!canUserEdit(
                            this.props.userData,
                            null,
                            FeatureCodes.MS_INFLATION_FACTOR_EDIT
                          ) ? "disabledBtnClass" : "btnClass"}
                          disabled={!canUserEdit(
                            this.props.userData,
                            null,
                            FeatureCodes.MS_INFLATION_FACTOR_EDIT
                          )}
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                              color: "white",
                              borderRadius: 15,
                            }}
                            block
                            htmlType="submit"
                            onClick={() =>
                              rowRecord.isEdit
                                ? this.submitTableRowData(rowRecord, index, false)
                                : this.handleEditChange(rowRecord, index)
                            }
                          >
                            {" "}
                            {rowRecord.isEdit ? "Submit" : "Edit"}{" "}
                          </Button>


                          <Button
                            className={!rowRecord.isEdit ? "disabledBtnClass" : "btnClass"}
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              color: "white",
                              borderRadius: 15,
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                            }}
                            block
                            htmlType="submit"
                            disabled={!rowRecord.isEdit}
                            onClick={() => this.handleCancelClick(rowRecord, index)
                            }
                          >
                            Cancel
                          </Button>

                        </div>
                      </>
                    );
                  },
                },
              ]}
              dataSource={this.setTableData()}
            />
          </div>

        </Spin>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  messageAccess: selectMSMessageRBAC,
});
export default connect(mapStateToProps)(InflationMaster);
//export default InflationMaster;
